import { useTranslation } from 'react-i18next';

import { ReloadIcon, WarningIcon } from '../../../images/shapes';

import Loader from '../../Loader/Loader';
import Tooltip from '../../Tooltip/Tooltip';
import TopbarButton from './base/TopbarButton';

const TopbarReconnectButton = ({
  onRetry,
  isRetrying,
}: {
  onRetry: () => void;
  isRetrying?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Tooltip
        tooltip={t('ContentForm.WsConnectionFailed')}
        additionalClasses="my-auto"
        tooltipPlacement="bottomCenter"
        phoneTooltipPlacement="bottomCenter"
      >
        <WarningIcon className="w-5 h-5 text-orange-500" />
      </Tooltip>
      <TopbarButton
        buttonColor="blue"
        iconImage={
          isRetrying ? (
            <Loader size="small" type="spinner-grid" />
          ) : (
            <ReloadIcon className="w-3 min-w-3" />
          )
        }
        label={t('ContentForm.WsRetry')}
        onClick={onRetry}
        disabled={isRetrying}
        testIdSuffix="ws-retry"
      />
    </>
  );
};

export default TopbarReconnectButton;
